// extracted by mini-css-extract-plugin
module.exports = {"btn":"BaseBtn_btn__DW7wz","md":"BaseBtn_md__2bK75","lg":"BaseBtn_lg__tJMDk"};